export const state = () => ({
    menu: [],
    showMenu: false,
    showMenuMobile: false,
    showNavigationMobile: false,
    showCasaNavigationMobile: false,
    actualPromoProducts: [],
    topCategories: [],
    viewMode: [],
    popularProducts: [],
    currentDomain: '',
    firstToKnow: {
        product: null,
        showModal: false
    },
    buyOneClick: {
        product: null,
        showModal: false
    },
    preorder: {
        product: null,
        showModal: false
    },
    additionallyModal: {
        products: null,
        showModal: false,
        isLoading: false
    },
    showShopModal: false,
    childCompanies: [],
    showErrorServer: false,
    showAuth: false,
    showRegister: false,
    showRegisterConfirmMessage: false,
    showSetNewPassword: false,
    showRequestNewPassword: false,
    showAgeRestriction: false,
    showRequestProfileDeleteModal: false,
    showProfileDeleteConfirmMessage: false,
    showProfileDeleteSuccessModal: false,
    showSuccessCreditCalculator: false,
    modalsEx: {
        gift: false,
        requestConsultation: false,
        requestConsultationSuccess: false
    },
    isRestorePasswordOpen: false,
    isNewPasswordOpen: false,
    isNuxtIntialize: false,
    browserId: null,
    previousLocale: '',
    locale: 'ru',
    headerShow: false,
    catalogShow: false,
    searchShow: false,
    newProducts: [],
    salesProducts: [],
    shops: [], // if local changing, value set to promise
    pendingLocaleChange: false,
    careersList: [],
    fileData: null,
    showResetPasswordConfirmMessage: false,
    errorServerText: null,
    showSuccesNotificationReview: false
});

export const getters = {
    getErrorServerText(state) {
        return state.errorServerText;
    },
    getMenu(state) {
        return state.menu;
    },
    getShowNotificationReview(state) {
        return state.showSuccesNotificationReview;
    },
    showMenu(state) {
        return state.showMenu;
    },
    getShowSuccessCreditCalculator(state) {
        return state.showSuccessCreditCalculator;
    },
    getShowShopModal(state) {
        return state.showShopModal;
    },
    getCurrentDomain(state) {
        return state.currentDomain;
    },
    showMenuMobile(state) {
        return state.showMenuMobile;
    },
    getShowNavigationMobile(state) {
        return state.showNavigationMobile;
    },
    getCasaShowNavigationMobile(state) {
        return state.showCasaNavigationMobile;
    },
    getShowSetNewPassword(state) {
        return state.showSetNewPassword;
    },
    getShowRequestNewPassword(state) {
        return state.showRequestNewPassword;
    },
    getShowAgeRestriction(state) {
        return state.showAgeRestriction;
    },

    getActualPromoProducts(state) {
        return state.actualPromoProducts;
    },
    getPopularProducts(state) {
        return state.popularProducts;
    },

    getTopCategories(state) {
        return state.topCategories;
    },
    getViewMode(state) {
        return state.viewMode;
    },

    getBuyOneClickData(state) {
        return state.buyOneClick;
    },

    getPreorderClickData(state) {
        return state.preorder;
    },

    getFirstToKnowClickData(state) {
        return state.firstToKnow;
    },

    getShowAdditionallyModal(state) {
        return state.additionallyModal.showModal;
    },
    getAdditionallyModalProducts(state) {
        return state.additionallyModal.products;
    },

    getBuyOneClickShowModal(state) {
        return state.buyOneClick.showModal;
    },

    getPreorderClickShowModal(state) {
        return state.preorder.showModal;
    },

    getFirstToKnowClickShowModal(state) {
        return state.firstToKnow.showModal;
    },

    getChildCompanies(state) {
        return state.childCompanies;
    },

    getShowErrorServer(state) {
        return state.showErrorServer;
    },

    getShowAuth(state) {
        return state.showAuth;
    },
    getShowRegister(state) {
        return state.showRegister;
    },
    getShowResetPasswordConfirmMessage(state) {
        return state.showResetPasswordConfirmMessage;
    },
    getShowRegisterConfirmMessage(state) {
        return state.showRegisterConfirmMessage;
    },
    getShowRequestProfileDeleteModal(state) {
        return state.showRequestProfileDeleteModal;
    },
    getShowProfileDeleteConfirmMessage(state) {
        return state.showProfileDeleteConfirmMessage;
    },
    getShowProfileDeleteSuccessModal(state) {
        return state.showProfileDeleteSuccessModal;
    },
    getModalGift(state) {
        return state.modalsEx.gift;
    },
    getModalRequestConsultation(state) {
        return state.modalsEx.requestConsultation;
    },
    getModalRequestConsultationSuccess(state) {
        return state.modalsEx.requestConsultationSuccess;
    },
    getRestorePasswordOpen(state) {
        return state.isRestorePasswordOpen;
    },
    getNewPasswordOpen(state) {
        return state.isNewPasswordOpen;
    },
    getIsNuxtIntialize(state) {
        return state.isNuxtIntialize;
    },
    getBrowserId(state) {
        return state.browserId;
    },
    getPreviousLocale(state) {
        return state.previousLocale;
    },
    getLocale(state) {
        return state.locale;
    },
    getStateHeader: s => s.headerShow,
    getStateCatalog: s => s.catalogShow,
    getStateSearch: s => s.searchShow,
    getNewProducts: s => s.newProducts,
    getSalesProducts: s => s.salesProducts,
    getShops: s => s.shops,
    getLocaleChange: s => s.pendingLocaleChange,
    getCareersList: s => s.careersList,
    getFileData: s => s.fileData
};

export const mutations = {
    SET_SHOW_RESET_PASSWORD_CONFIRM_MESSAGE(state, value) {
        state.showResetPasswordConfirmMessage = value;
    },
    SET_SHOW_SUCCESS_NOTIFICATION_REVIEW(state, value) {
        state.showSuccesNotificationReview = value;
    },
    SET_SHOW_SUCCESS_CREDIT_CALCULATOR(state, value) {
        state.showSuccessCreditCalculator = value;
    },
    SET_SHOW_AUTH(state, value) {
        state.showAuth = value;
    },
    SET_SHOW_REGISTER(state, value) {
        state.showRegister = value;
    },
    SET_SHOW_REGISTER_CONFIRM_MESSAGE(state, value) {
        state.showRegisterConfirmMessage = value;
    },
    SET_SHOW_SET_NEW_PASSWORD(state, value) {
        state.showSetNewPassword = value;
    },
    SET_SHOW_REQUEST_NEW_PASSWORD(state, value) {
        state.showRequestNewPassword = value;
    },
    SET_SHOW_AGE_RESTRICTION(state, value) {
        state.showAgeRestriction = value;
    },
    SET_SHOW_REQUEST_PROFILE_DELETE_MODAL(state, value) {
        state.showRequestProfileDeleteModal = value;
    },
    SET_SHOW_PROFILE_DELETE_CONFIRM_MESSAGE(state, value) {
        state.showProfileDeleteConfirmMessage = value;
    },
    SET_PROFILE_DELETE_SUCCESS_MODAL(state, value) {
        state.showProfileDeleteSuccessModal = value;
    },
    setShowMenu(state, value) {
        state.showMenu = value;
    },
    setShowShopModal(state, value) {
        state.showShopModal = value;
    },
    setShowMenuMobile(state, value) {
        state.showMenuMobile = value;
    },
    setShowNavigationMobile(state, value) {
        state.showNavigationMobile = value;
    },
    SET_CASA_NAVIGATION_MOBILE(state, value) {
        state.showCasaNavigationMobile = value;
    },
    setBuyOneClickProduct(state, product) {
        state.buyOneClick.product = product;
    },

    setFirstToKnowProduct(state, product) {
        state.firstToKnow.product = product;
    },

    setPreorderProduct(state, product) {
        state.preorder.product = product;
    },

    setBuyOneClickModalShow(state, value) {
        state.buyOneClick.showModal = value;
    },

    setAdditionallyModalShow(state, value) {
        state.additionallyModal.showModal = value;
    },

    setAdditionallyModalProducts(state, value) {
        state.additionallyModal.products = value;
    },

    setProductQuantity(state, { index, quantity }) {
        state.additionallyModal.products[index].quantity = quantity;
    },

    setAdditionallyModalLoading(state, value) {
        state.additionallyModal.isLoading = value;
    },

    setFirstToKnowModalShow(state, value) {
        state.firstToKnow.showModal = value;
    },

    setPreorderProductModalShow(state, value) {
        state.preorder.showModal = value;
    },

    setTopCategories(state, categories) {
        state.topCategories = categories;
    },
    setViewMode(state, categories) {
        state.viewMode = categories;
    },
    setMainMenu(state, menu) {
        state.menu = menu;
    },
    setCurrentDomain(state, domain) {
        state.currentDomain = domain;
    },
    setPopularProducts(state, products) {
        state.popularProducts = products;
    },
    setPromoProducts(state, products) {
        state.actualPromoProducts = products;
    },
    setErrorServerText(state, value) {
        state.errorServerText = value;
    },
    setShowErrorServer(state, value) {
        state.showErrorServer = value;
    },
    setModalGift(state, value) {
        state.modalsEx.gift = value;
    },
    setModalRequestConsultationSuccess(state, value) {
        state.modalsEx.requestConsultationSuccess = value;
    },
    setModalRequestConsultation(state, value) {
        state.modalsEx.requestConsultation = value;
    },
    SET_IS_NUXT_INIT(state, value) {
        state.isNuxtIntialize = value;
    },
    SET_BROWSER_ID(state, payload) {
        state.browserId = payload;
    },
    SET_PREVIOUS_LOCALE(state, locale) {
        state.previousLocale = locale;
    },
    SET_LOCALE(state, locale) {
        state.locale = locale;
    },
    setStateHeader(state, payload) {
        state.headerShow = payload;
    },
    setStateCatalog(state, payload) {
        state.catalogShow = !!payload;
    },
    setStateSearch(state, payload) {
        state.searchShow = payload;
    },
    setNewProducts(state, payload) {
        state.newProducts = payload;
    },
    setSalesProducts(state, payload) {
        state.salesProducts = payload;
    },
    setShops(state, payload) {
        state.shops = payload;
    },
    setLocaleChange(state, payload) {
        state.pendingLocaleChange = payload;
    },
    setCareersList(state, payload) {
        state.careersList = payload;
    },
    SET_FILE_DATA(state, payload) {
        state.fileData = payload;
    }
};

export const actions = {
    firstToKnowClick(context, product) {
        context.commit('setFirstToKnowProduct', product);
        context.commit('setFirstToKnowModalShow', true);
    },
    buyOneClickProduct(context, product) {
        context.commit('setBuyOneClickProduct', product);
        context.commit('setBuyOneClickModalShow', true);
    },
    preorderProductClick(context, product) {
        context.commit('setPreorderProduct', product);
        context.commit('setPreorderProductModalShow', true);
    },
    async additionallyModalClick(context, category) {
        context.commit('setAdditionallyModalShow', true);
        await context.dispatch('fetchAdditionallyProducts', category);
    },
    async setShowAuth(context, flag) {
        context.commit('SET_SHOW_AUTH', flag);
    },
    async setShowRegister(context, flag) {
        context.commit('SET_SHOW_REGISTER', flag);
    },
    async setShowResetPasswordConfirmMessage(context, flag) {
        context.commit('SET_SHOW_RESET_PASSWORD_CONFIRM_MESSAGE', flag);
    },
    async setShowRegisterConfirmMessage(context, flag) {
        context.commit('SET_SHOW_REGISTER_CONFIRM_MESSAGE', flag);
    },
    async setShowSetNewPassword(context, flag) {
        context.commit('SET_SHOW_SET_NEW_PASSWORD', flag);
    },
    async setShowRequestNewPassword(context, flag) {
        context.commit('SET_SHOW_REQUEST_NEW_PASSWORD', flag);
    },
    async setShowAgeRestriction(context, flag) {
        context.commit('SET_SHOW_AGE_RESTRICTION', flag);
    },
    async setShowSuccessCreditCalculator(context, flag) {
        context.commit('SET_SHOW_SUCCESS_CREDIT_CALCULATOR', flag);
    },
    async fetchAdditionallyProducts({ commit }, { type }) {
        commit('setAdditionallyModalLoading', true);
        try {
            const response = await import(`~/JsonDB/${type}.json`);

            const result = response.default[type].map(product => {
                return {
                    ...product,
                    quantity: 1
                };
            });
            commit('setAdditionallyModalProducts', result);
        } catch (e) {
            console.error(e);
        } finally {
            commit('setAdditionallyModalLoading', false);
        }
    },
    async fetchNewProducts({ commit }) {
        try {
            // const response = await this.$apiCache.$get(
            //   `${this.$i18n.locale === 'ru' ? 'ru' : ''}/main/slider-new_products/`,
            //   { useCache: true }
            // )
            const response = await this.$axios.$get(`${this.$i18n.locale}/main/slider-new_products/`);
            const prIsStock = response.filter(el => el.is_stock);
            commit('setNewProducts', prIsStock.slice(0, 10));
        } catch (e) {
            console.error(e);
        }
    },
    async fetchPopularProducts({ commit }) {
        try {
            const response = await this.$axios.$get(`${this.$i18n.locale}/main/slides-popular-product/`);
            commit('setPopularProducts', response);
        } catch (e) {
            console.error(e);
        }
    },
    async fetchSalesProducts({ commit }) {
        try {
            const {
                products: { results: results }
            } = await this.$axios.$get(`${this.$i18n.locale}/shop/product/?type=discount&page_size=10`);
            const prIsStock = results.filter(el => el.is_stock);
            commit('setSalesProducts', prIsStock);
        } catch (e) {
            console.error(e);
        }
    },
    async fetchShops({ commit }) {
        try {
            const response = await this.$api.$get('/shop/get-stores/');
            response.sort((a, b) => a.sorted - b.sorted);
            commit('setShops', response);
        } catch (er) {
            console.log(er);
        }
    },
    async setCareersList({ commit }, data) {
        try {
            commit('setCareersList', data);
        } catch (er) {
            console.error(er);
        }
    },
    async fetchMainPageSimilarCategory({ commit }) {
        try {
            const { categories, view_mode } = await this.$axios.$get('base/main_page_similar_category');
            if (categories && categories?.length) {
                commit('setViewMode', view_mode);
                commit('setTopCategories', categories);
            }
        } catch (error) {
            console.error('Error fetching main page similar category:', error);
        }
    },
    async fetchFileData({ commit }) {
        try {
            const data = await this.$axios.$get('settings/default-site-files/');

            commit('SET_FILE_DATA', data);
        } catch (error) {
            console.error(e);
        }
    },
    nuxtServerInit: async function ({ commit, dispatch, getters }, { req, app }) {
        await dispatch('global/fetchGlobalSettings');

        await dispatch('global/initializeFarmacieToken');
        await dispatch('global/initializeNovaPortaToken');
        await dispatch('global/initializeCasaDelTabacoToken');
        await dispatch('global/initializeUniPlastToken');
        await dispatch('global/initializeItalTechToken');
        await dispatch('global/initializeHabsevToken');
        await dispatch('global/initializeJblToken');
        await dispatch('global/initializeEcaterixToken');
        await dispatch('global/initializeUniPlastToken');
        await dispatch('global/initializeMasterDoorsToken');

        const locale = app.$cookies.get('language') || getters['global/getMainlang'] || 'ru';
        commit('SET_LOCALE', locale);
    }
};
